/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8fdc1068ec6b94cfdf4447822f5a173f0726c1c0";
